export function externalLinkBaseUrl(company) {
  const googlePlayUrl = company.googlePlayUrl ? encodeURIComponent(company.googlePlayUrl) : null;
  const appStoreUrl = company.appStoreUrl ? encodeURIComponent(company.appStoreUrl) : null;

  return googlePlayUrl && appStoreUrl ? `tx-app://out?googleplay=${googlePlayUrl}&appstore=${appStoreUrl}` : null;
}
